module.exports = __webpack_public_path__ + "static/media/CYRKULACJA-on.f9c5e5df.svg";